<div class="row">
  <div class="col-sm-12">
    <button id="{{ idElement }}" class="green-button" [disabled]="disabled">
      <ng-content></ng-content>
    </button>
  </div>
</div>
